var map = {
	"./420.jpg": 35,
	"./angel.jpeg": 36,
	"./animal_skull.jpg": 37,
	"./aquarelle_bug.jpg": 38,
	"./arm_tattoo.jpg": 39,
	"./bird.jpg": 40,
	"./birds.jpg": 41,
	"./black_and_white_birch_with_eyes.jpg": 42,
	"./black_and_white_flower.jpg": 43,
	"./black_and_white_mandala.jpg": 44,
	"./black_and_white_woman.jpg": 45,
	"./black_and_white_woman_line.jpg": 46,
	"./bluebird.jpg": 47,
	"./buddhahead.jpg": 48,
	"./butterfly.jpg": 49,
	"./cactus.jpg": 50,
	"./compass.jpg": 51,
	"./devil.jpg": 52,
	"./devil2.jpg": 53,
	"./dog.jpg": 54,
	"./donald_duck.jpg": 55,
	"./eye.jpg": 56,
	"./falcon_mandala_black_and_red.jpg": 57,
	"./handTattoo.jpeg": 58,
	"./hand_tattoo.jpg": 59,
	"./japanese_dragon.jpg": 60,
	"./kalevala.jpg": 61,
	"./leg_tattoo_tribal.jpg": 62,
	"./leopard.jpg": 63,
	"./lettering.jpg": 64,
	"./lotus_mandala.jpg": 65,
	"./mandala.jpg": 66,
	"./mandala2.jpg": 67,
	"./mandala_leg.jpg": 68,
	"./mandala_wolf.jpg": 69,
	"./moon.jpg": 70,
	"./mutsi.jpeg": 71,
	"./pinecone.jpg": 72,
	"./pinetree.jpg": 73,
	"./queenbee.jpg": 74,
	"./shark.jpg": 75,
	"./sketching.jpg": 76,
	"./sketching2.jpg": 77,
	"./sketching3.jpg": 78,
	"./sketching4.jpg": 79,
	"./skull_colour.jpg": 80,
	"./skullbug.jpg": 81,
	"./snake.jpg": 82,
	"./snake2.jpg": 83,
	"./soulbird.jpg": 84,
	"./space_back.jpg": 85,
	"./spineTattoo.jpg": 86,
	"./universe_hair_girl.jpg": 87,
	"./whale.jpg": 88,
	"./wolf.jpg": 89,
	"./wolfComplete.jpg": 90,
	"./wolfScetch.jpg": 91,
	"./womanandgun.jpg": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;